type Ratings = {
  good: number;
  neutral: number;
  poor: number;
  total: number;
};

export function DonutChart({ ratings }: { ratings: Ratings | undefined }) {
  if (!ratings) return;

  const goodLength = (ratings.good / ratings.total) * 100;
  const neutralLength = (ratings.neutral / ratings.total) * 100;
  const poorLength = (ratings.poor / ratings.total) * 100;

  return (
    <div className="bg-primary rounded-lg mt-3">
      <div className="relative mx-auto h-24 w-24">
        <svg className="h-full w-full -rotate-90" viewBox="0 0 36 36">
          <circle
            className="fill-none stroke-gray-200"
            cx="18"
            cy="18"
            r="16"
            strokeWidth="4"
          />
          <circle
            className="fill-none stroke-utility-warning-500"
            cx="18"
            cy="18"
            r="16"
            strokeDasharray={`${neutralLength} ${100 - neutralLength}`}
            strokeDashoffset={`${-goodLength}`}
            strokeWidth="4"
          />
          <circle
            className="fill-none stroke-utility-error-500"
            cx="18"
            cy="18"
            r="16"
            strokeDasharray={`${poorLength} ${100 - poorLength}`}
            strokeDashoffset={`${-(goodLength + neutralLength)}`}
            strokeWidth="4"
          />
          <circle
            className="fill-none stroke-utility-success-500"
            cx="18"
            cy="18"
            r="16"
            strokeDasharray={`${goodLength} ${100 - goodLength}`}
            strokeDashoffset="0"
            strokeWidth="4"
          />
        </svg>
        <div className="absolute inset-0 grid place-items-center">
          <div className="text-center">
            <p className="text-xl font-semibold text-text-primary">
              {ratings.total
                ? ((ratings.good / ratings.total) * 100).toFixed(0) + "%"
                : "0%"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
